import React from "react";
import PropTypes from "prop-types";
import { useForm } from "react-hook-form";
import { FormProvider } from "../FormProvider";
import RenderProductPageUpsellSlot from "./RenderProductPageUpsellSlot";
import useEmbeddedUpsellAnalytics from "../../hooks/useEmbeddedUpsellAnalytics";
import { getProductPageSlotNo } from "../../../shared/product-page-slot.js";

/**
 * Storefront product page slot needs react-hook-form for variant picker + add-to-cart.
 */
export default function ProductPageUpsellFormShell({
  popupData,
  activeStep,
  isMobile,
  popupState,
}) {
  const methods = useForm({
    defaultValues: {},
    mode: "onSubmit",
  });
  const { handleSubmit } = methods;

  useEmbeddedUpsellAnalytics({
    popupData,
    activeStep,
    enabled: true,
    slotNo: getProductPageSlotNo(popupData),
  });

  return (
    <FormProvider
      popupData={popupData}
      popupState={popupState}
      methods={methods}
      onSubmit={handleSubmit(() => {})}
    >
      <RenderProductPageUpsellSlot
        popupData={popupData}
        activeStep={activeStep}
        isMobile={isMobile}
      />
    </FormProvider>
  );
}

ProductPageUpsellFormShell.propTypes = {
  popupData: PropTypes.object.isRequired,
  activeStep: PropTypes.number,
  isMobile: PropTypes.bool,
  popupState: PropTypes.object,
};
